<div #pane class="pane">
    <div *ngIf="title">
        <div style="height: 20px;"></div>
        <div class="b1Color h2Font title">{{title}}</div>
        <div style="height: 14px;"></div>
    </div>
    <ng-container *ngComponentOutlet="contentComponent"></ng-container>
</div>

